import { useSelector } from "react-redux";
import "./fishPrint.css";
import ReactToPrint from "react-to-print";
import { useEffect, useRef } from "react";
import BasicButton from "components/BasicInputs/BasicButton";
import PrinterIcon from "assets/icons/PrinterIcon";
import useFishPrint from "./useFishPrint";

export interface FishPrintProps {
  factor: Factor;
}
export default function FishPrint(props: FishPrintProps) {
  const store = useSelector((state: any) => state);
  const factor: Factor = store.factorReducer?.factor;
  const business = store.businessReducer.business.business;
  const ref = useRef<any>(null);
  const { content, contentRef } = useFishPrint();

  useEffect(() => {
    // ref?.current?.handleClick();
  }, []);

  if (!factor) {
    return (
      <div className="flex justify-center items-center w-full h-full pt-10 pb-10">
        <div className="w-[300px] bg-white flex flex-col items-center py-6 text-black p-2 ">
          لطفا یک فاکتور انتخاب کنید
        </div>
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-2 justify-center items-center w-full h-full pt-10 pb-10">
      {content}
      <ReactToPrint
        ref={ref}
        trigger={() => (
          <BasicButton fullWidth variant="contained" style={{ gap: "20px", width: 150 }}>
            <PrinterIcon />
            <span>چاپ فاکتور</span>
          </BasicButton>
        )}
        content={() => contentRef.current}
      />
    </div>
  );
}
